module.exports = __webpack_public_path__ + "img/UE_EFRR_rgb-1.c505576d.webp";